<script setup>
import { useI18n } from 'vue-i18n';
import { RouterLink } from 'vue-router';
import Logo from './Logo.vue';
import WhatsAppButton from './WhatsAppButton.vue';

const { t } = useI18n();

defineEmits(['close']);
</script>

<template>
  <div class="fixed inset-0 z-[100]">
    <!-- Dark overlay -->
    <div
      class="fixed inset-0 bg-black/80 backdrop-blur-sm"
      @click="$emit('close')"
      aria-hidden="true"
    ></div>

    <!-- Menu panel -->
    <div
      id="mobile-menu"
      class="fixed top-0 right-0 w-full h-full max-w-sm px-6 py-8 bg-white shadow-lg"
      role="dialog"
      aria-modal="true"
      aria-label="Mobile navigation menu"
    >
      <div class="flex justify-end mb-8">
        <button
          @click="$emit('close')"
          class="p-2 transition-colors rounded-full hover:bg-black/5"
          aria-label="Close mobile navigation menu"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <nav class="flex flex-col items-center gap-8" role="navigation" aria-label="Mobile navigation">
        <Logo size="large" />
        <RouterLink
          to="/"
          @click="$emit('close')"
          class="text-2xl font-medium transition-colors hover:text-black/70"
          :aria-current="$route.path === '/' ? 'page' : undefined"
        >
          {{ t('header.nav.home') }}
        </RouterLink>
        <RouterLink
          to="/services"
          @click="$emit('close')"
          class="text-2xl font-medium transition-colors hover:text-black/70"
          :aria-current="$route.path === '/services' ? 'page' : undefined"
        >
          {{ t('header.nav.services') }}
        </RouterLink>
        <RouterLink
          to="/panel"
          @click="$emit('close')"
          class="text-2xl font-medium transition-colors hover:text-black/70"
          :aria-current="$route.path === '/panel' ? 'page' : undefined"
        >
          {{ t('header.nav.insurance') }}
        </RouterLink>
        <RouterLink
          to="/about"
          @click="$emit('close')"
          class="text-2xl font-medium transition-colors hover:text-black/70"
          :aria-current="$route.path === '/about' ? 'page' : undefined"
        >
          {{ t('header.nav.about') }}
        </RouterLink>
        <WhatsAppButton class=" md:flex" />
      </nav>
    </div>
  </div>
</template>